import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";
import Services from "@/components/site/Services";
import ContactCta from "@/components/site/ContactCta";
import { waLink } from "@/lib/site";
import { applySeo, ROUTE_SEO } from "@/lib/seo";

export default function SurfLessons() {
  useEffect(() => {
    applySeo(ROUTE_SEO["/surf-lessons"]);
  }, []);

  return (
    <div className="bg-sand-50 text-ink font-sans antialiased min-h-screen">
      <Navbar />
      <main>
        <section className="py-16 bg-sand-100 border-b border-sand-200" data-testid="services-page-header">
          <div className="max-w-7xl mx-auto px-6">
            <span className="text-xs font-mono-clean text-terracotta uppercase tracking-wider font-semibold">
              Full Surf Service
            </span>
            <h1 className="font-display text-4xl sm:text-5xl font-bold text-ocean-900 mt-3">
              Surf lessons, photography & transfers
            </h1>
            <p className="text-sm text-fog mt-4 max-w-2xl leading-relaxed">
              Everything dialled for your sessions at Lagundri Bay — local
              coaching in the bay, daily water and land photography, and direct
              airport transfers with roof racks for your whole quiver.
            </p>
          </div>
        </section>
        <Services />
        <section className="py-16 bg-sand-100 border-t border-sand-200" data-testid="services-detail">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h2 className="font-display text-2xl sm:text-3xl font-bold text-ocean-900">
              Travelling with surfboards?
            </h2>
            <p className="text-sm text-fog mt-3 max-w-xl mx-auto">
              Airlines charge heavily for boards into Nias. We ship board bags
              overland from Medan and Padang at fixed rates, delivered to our
              reception before your first session.
            </p>
            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/board-transfer"
                data-testid="services-board-transfer-link"
                className="px-6 py-3.5 rounded-xl bg-ocean-700 text-white text-xs font-semibold uppercase tracking-wider hover:bg-ocean-800 transition-colors"
              >
                Board Transfer Details
              </Link>
              <a
                href={waLink("Hello Raffiel Nias, I'd like to book a surf lesson.")}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="services-lesson-whatsapp"
                className="px-6 py-3.5 rounded-xl bg-white border border-sand-200 text-ocean-900 text-xs font-semibold uppercase tracking-wider hover:bg-sand-50 transition-colors"
              >
                Book a Lesson on WhatsApp
              </a>
            </div>
          </div>
        </section>
        <ContactCta />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
